<template>
  <div class="agreement">
    <CoachAgreement v-if="isCoach" />
    <template v-else>
      <div>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
          text-align: center;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span>
          <span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户协议</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">导言</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">尊敬的用户：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">非常感谢您注册使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品，为让您更好地使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务，请您务必审慎阅读、充分理解《</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户协议》（以下称「用户协议」或「本协议」）各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。本协议中限制、免责条款可能以加粗形式提醒您注意。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供相关产品和服务。您的下载、安装、使用、登陆等行为即视为您已阅读并同意本协议的约束。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">1.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">协议的范围</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">App</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">、微信小程序及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">H5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">网页程序（以下统称「</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品」）是由{{ companyName }}及其关联公司（以下称「</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">」或「我们」）提供的互联网产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本用户协议是用户（您）与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">之间关于使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务所订立的协议，本协议条款的效力及于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">所提供的一切产品和服务，用户在享受</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">任何单项服务时，应当受本协议的约束。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本协议项下的产品和服务是指由</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务、智能硬件和广告等的互联网产品和服务（形式包括但不限于在线视频、评论、跟帖、弹幕、图片、软件、技术代码等）。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本协议内容同时包括《隐私政策》及所有</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">已经发布或未来可能发布的各类规则、公告或通知，且您在使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">某一特定产品或服务时，可能会另有单独的协议、相关服务规则等，前述规则、公告、通知和协议一经发布即为本协议不可分割的组成部分，您同样应当遵守。如您不同意本协议的约定，您应立即停止注册</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">激活并停止使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的相关产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权根据需要不时地修订本协议及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">或各类规则（包括但不限于制定新的条款和修改既有条款），并以在线公告的方式进行变更公告，无须另行单独通知您。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">除本协议明确规定外，对于利用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">开发</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">发布的产品和服务，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权在本协议的基础上通过单独的产品和服务协议（以下称「单项产品协议」）加以规范，用户须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如用户使用该产品或服务，即视为对相关单项产品协议的接受。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">2.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">产品及服务简介</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为用户提供多样的互联网产品和服务，包括但不限于训练课程、跑步、步行、骑行、营养师服务、电商等相关产品，用户可以通过</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品使用、分享、购买</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务。用户有权获得</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务，但</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权收取由此产生的服务或产品费用。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">2.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">尽力提供畅通无阻的在线服务，但平台的网络接入服务可能受多种因素的影响出现链接受阻、受限或被终止，由此给您带来的损失、不便，我们将不负任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的部分产品和服务须付费使用，用户使用此类产品须向</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">支付一定的费用。对于收费的产品和服务，我们会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">继续使用该等收费产品和服务。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">如用户拒绝支付相关费用，则</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权不向用户提供该等收费产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">仅提供在线产品和服务，除此之外与网络服务有关的设备（如手机、个人电脑、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的替换、修改和升级：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.5.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为增进用户体验、完善服务内容，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权根据您对软件、程序的使用状态和行为开发新的服务；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.5.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为改进、增强和进一步开发服务，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权不时提供软件、程序更新（包括软件、程序升级替换、修改、功能强化、版本升级等形式）；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.5.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户理解并同意：</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权不向您特别通知而对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">进行更新，或对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的部分功能进行改变或限制。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.5.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">新版本发布后，旧版本可能无法使用。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不保证旧版</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">及相应的服务继续可用。为充分、及时使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的服务，请您随时核对并下载最新版本。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">第三方应用及服务</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品中提供了支持第三方应用供用户使用的功能模块，包括但不限于工具类服务、视频或图片类服务等，以及今后可能出现的各种服务。用户在使用该类应用程序时，应遵守本协议及该应用程序相应的协议、条款或规则的规定。用户与开发者之间的权利义务，参照相关协议、条款或规则执行。用户在使用第三方提供的软件和服务时，须了解并同意：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.6.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户使用第三方开发者提供的应用与服务时，第三方开发者将根据用户授权获得用户的个人资料和内容信息。这些资料和信息由用户自行决定授权给第三方。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户须明确：您向第三方授权获得您个人资料和内容信息的行为，可能发生的信息泄露的风险；您在使用第三方服务的同时，除遵守本协议及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的其他相关规则外，您还应遵守第三方的协议、相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您自行与第三方解决，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对此不承担责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">2.6.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">引入第三方服务的目的在于丰富</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">产品，从而给用户创造更好的服务体验。但因第三方服务出现的瑕疵或错误而产生的责任，由第三方自行承担，与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">无关。当然，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">会对第三方提供的服务进行审查或审核，但基于服务的专业性，难免存在遗漏。第三方服务商并不因</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的审查或审核疏漏而免于责任承担。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.6.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">对第三方开发者提供的应用享有审核管理权，有权在不通知用户的情况下，对第三方应用进行下架处理，由此给用户带来的影响、损失，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">将不承担责任，由用户自行承担或与第三方协商，但</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">将尽力保障用户权益不受侵犯。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">2.6.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户使用第三方应用时，须同意：（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">）授权使用自己的</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">账号登陆第三方应用；（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">）同意第三方应用获取自己的个人资料，以获得相应产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2.6.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户因使用第三方应用而与该第三方开发者产生的任何纠纷，由用户与开发者自行协商解决，相关责任和赔偿由开发者单独承担，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不承担任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">3.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">电商服务</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为满足用户对健身周边产品的需求，本站特向用户提供电商服务。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">销售的商品为自营产品以及他营产品。在售产品信息可至</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">微信小程序、</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">App</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">H5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">网页程序内的商城进行浏览、查询及购买。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">商品信息</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">商品价格、数量、性能介绍、是否有货等商品信息随时都有可能发生变动，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不作特别通知，请用户至商品销售页面自行查看。我们会尽最大努力保证您所浏览的商品信息的准确性，但由于商品种类繁多且商品信息的数量较大，加之互联网技术因素等客观原因存在，本站显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">欢迎纠错，并会视情况给予纠错者一定的奖励。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">订单</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">在您下订单时，请仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、收货人、电话、收货地址等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。您提交订单即表示对订单中所确认的订购商品、收货地址等信息的准确性负责。如果因为您填写的收货人联系电话、地址等信息错误，导致我们（或我们委托的配送公司）将货物交付给非您本意的收货人的，由此造成的损失需由您自行承担。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">如果您通过</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">订购商品，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品展示的商品和价格等信息仅仅作为要约邀请，您的订单将成为订购商品的要约。收到您的订单后，我们会及时为您发货，只有当我们向您发出发货确认的电子邮件、短信或程序内通知，通知您我们已将您订购的商品发出时，才构成我们对您的订单的接受，您与我们之间的订购合同才成立。如果您在一份订单里订购了多种商品，而我们只向您发出了其中部分商品的发货确认电子邮件或短信，那么我们和您之间的订购合同仅就该部分商品成立。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">由于市场变化及各种以合理商业努力难以控制的因素的影响，如您拟购买的商品，在任何购买环节发生缺货或无货，您有权取消订单。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为回馈用户的支持，我们会不定期向用户发放一些优惠券或代金券，上述优惠券或代金券的发放数量及使用规则由</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">自行决定。您有权按照优惠券或代金券的使用规则在本站购物时的使用，严禁转卖</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">优惠券或代金券或利用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户进行其他经营性行为等。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.2.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">关于支付形式、商品退换货、售后服务等相关问题，请在商品销售页面查看。若您在商品购买过程中遇到任何问题，均可致电</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">0731-84484800</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">，我们的客服人员会及时与您取得联系并帮助您解决问题。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">配送</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.3.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">我们将会把商品（货物）送到您指定的收货地址，所有在本站上列出的以及客服告知的送达时间为参考时间，参考时间的计算是在综合考量库存状况、正常的处理过程和送货时间、送货地点的基础上估算得出的。参考时间可能与实际送达的时间有所出入，请您知悉并理解。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3.3.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">因如下情形造成订单延迟或无法配送等，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不承担延迟配送的责任：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）因用户提供的信息错误、地址不详细等原因导致的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）货物送达后无人签收，导致无法配送或延迟配送的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）情势变更因素导致的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">4.</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">会员服务</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.1</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">会员服务，指会员享有的特殊服务，以下简称「会员」。包括会员有效期内无限次免费使用专属训练计划制以及其他由</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">明示的优惠措施。用户开通会员服务时，须按照</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">公布的收费标准支付相应的会员服务费用。基于业务的发展，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权调整收费标准，调整后的收费标准自公布之日起生效。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.2</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">由于您购买的商品为虚拟内容服务，您在已开通的服务期内中途主动取消服务或终止资格的，将无法退还为开通本服务而支付的费用。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.3</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">使用会员服务过程中，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应当承担因此而导致的一切后果，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权向您的监护人追偿。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.4</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您知悉并同意，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权通邮件、短信等方式，向您发送会员相关活动的信息。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.5</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您确认会员服务仅限您本人使用，同时，您保证，您将合理使用会员服务，不会利用会员服务非法获利，不以任何形式转让您所享有的会员服务，不以任何形式将您所享有的会员服务借给他人使用，如</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有合理理由怀疑您存在不当使用会员服务时，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权取消您的会员资格且不退还您支付的会员服务费用，因此产生的相关责任及损失均由您自行承担，给</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">造成损失的，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">保留向您追偿的权利。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">4.6</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">保留在法律法规允许的范围内自行决定是否接受您的会员服务申请、调整会员服务内容、取消会员资格等权利。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">5.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">知识产权声明</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">5.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">依法享有</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品的一切合法权属（包括但不限于知识产权及所有权）。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的全部著作权及其他一切知识产权，以及与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图标、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规和有关的国际条约的保护。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">5.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品及通过</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品提供的视频、游戏、技术软件等产品和信息，除用户自己上传或明确标示由第三方提供的之外，全部权利归属于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">5.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">在涉及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品及相关各项服务中拥有专利权、专利申请权、商标权、著作权及其他知识产权。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">并未因为本协议或者因为向用户提供</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">以及相关产品和服务而授予用户任何与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">相关的知识产权。本协议未明确授予用户的权利均由</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">保留。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户隐私制度</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">6.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">保护用户个人信息是</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的一项基本原则。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">6.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您在注册账号或使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的产品或服务，或在使用过程中受到限制。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">6.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如账号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">保留您修改个人信息的审核权。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不会将您的个人信息转移或披露给任何非关联的第三方，除非：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">相关法律法规或法院、政府机关要求；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">为完成合并、分立、收购或资产转让而转移；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">事先获得您的授权；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">您使用共享功能；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">以学术研究或公共利益为目的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">在法律法规和政策允许的范围内，为提升用户体验和提供个性化的推广服务；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.4.7</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">我们认为必要且不违反法律强制性规定的其他情形。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">6.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">6.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">非常重视对未成年人信息的保护。若您是</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">18</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">周岁以下的未成年人，在使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的服务前，您请在父母或监护人监护、指导下共同仔细阅读并理解本用户协议，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。如因您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户的账号、密码和安全性</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">注册资格</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您确认，在您完成注册程序或以其他</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">允许的方式实际使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务时，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权注销或永久冻结您的账户，并保留向您或您的监护人索取赔偿的权利。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">18</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">周岁以下的未成年人等非完全民事行为能力人应该在法定监护人的指导下使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的产品和服务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">注册与账户</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.2.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">为完整使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的产品和服务，您须注册</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">提供的账户。用户（您）注册</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户时须对所提供信息的真实性、合法性、有效性及完整性负责，并及时维护和更新您的个人信息，以保证信息的真实、合法和有效。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.2.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">中的注册账号所有权及有关权益均归公司所有，您完成注册手续后仅享有该账号的使用权。您的账号仅限于您本人使用，未经</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">发现或者有合理理由认为使用者并非账号初始注册人，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权暂时或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">在此特别提醒您务必保护好您的账号及密码，切勿将账号及密码透露给他人。您须自行负责对您的账户和密码进行保密，且须对在您的账户和密码下发生的所有活动（包括但不限于信息披露、信息发布、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不能也不会对因您未能遵守本条款规定而发生的任何损失负责。若您发现任何人未经授权使用您的账号及密码，您须立即通知</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">。你可以发送邮件至提出您的请求。您须理解并同意</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">根据您的请求采取行动需要合理时间，对在采取行动前已产生的任何不利后果，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不承担任何责任。因其他人恶意攻击或您自身原因或其他不可抗因素而导致账号盗窃、丢失、均由您本人承担责任，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不承担任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">您可以对账户设置昵称，您设置的昵称不得侵犯或涉嫌侵犯他人的合法权益。用户承诺设置昵称时遵守以下规定：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.4.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.4.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不以国家机构或其他机构的名称注册；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.4.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的账号；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.4.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不注册易产生歧义、引起他人误解或其它不符合法律规定的账号。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">如您设置的昵称涉嫌侵犯他人合法权益，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权终止向您提供部分或全部软件服务。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户同意授权</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">基于下列原因使用用户的信息资源</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">执行软件验证、升级服务；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">提高用户的使用安全性或提供客户支持；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">应用户特殊要求而提供特定服务时，需要将信息提供给</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">或与此相关联的第三方或其他用户；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册、促销或其他活动等；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">应司法机关或政府机关要求；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">为提高用户使用体验；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">7.5.7</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">其他有利于用户和</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">利益且不违反任何强制性法律法规的情况。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">7.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户注销</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">如果您已经深思熟虑，确定放弃您的</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户，并符合</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">规定的所有注销条件，均可致电</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">0731-84484800</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">申请注销</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户一旦被注销将不可恢复，请您在操作之前自行备份</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">账户相关的所有信息和数据。请您保存好订单商品和服务的交易凭证、票据等资料，否则您有可能须支付额外的账户和订单查询费用，或无法享受售后服务。因您的账户申请注销对您造成的不利影响，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">将不承担任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">8.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">使用规范</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户须对自己的上网行为负责，包括对自己发表、上传或传送的内容（包括文字、评论、跟帖、弹幕、图片、视频内容、软件产品等）负全部责任。用户须承诺在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">平台上所发布的任何内容均符合中华人民共和国法律、法规、规章以及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">管理规范的规定。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权对用户发布的任何不符合管理规定的内容予以删除，且不承担任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">致力于营造文明、理性、友善、高质量的社区交流环境。在用户使用评论、跟帖、弹幕等功能时，需按照相关法律法规等的规定进行实名认证，否则，您将无法使用上述功能。在使用评论等相关功能时，您需严格遵守国家相关法律法规的规定。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">在推动跟帖评论等业务发展的同时，不断加强相应的信息安全管理能力，完善跟帖评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户承诺在使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品和服务（包括但不限于：文字、评论、跟帖、弹幕、图片、视频内容、软件产品等）过程中，应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">“</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">七条底线</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">”</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">要求，不发布、转载、传送含有下列内容之一的内容，否则</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权自行处理并不通知用户。用户不得发表下列信息：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">反对宪法确定的基本原则的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">危害国家安全，泄漏国家机密；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">损害国家荣誉和利益的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">宣扬恐怖主义、极端主义的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">宣扬民族仇恨、民族歧视，破坏民族团结的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.7</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">煽动地域歧视、地域仇恨的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.8</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">破坏国家宗教政策，宣扬邪教和迷信的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.9</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">编造、散布谣言、虚假信息，扰乱社会秩序、破坏社会稳定的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.10</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.11</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">危害网络安全、利用网络从事危害国家安全、荣誉和利益的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.12</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">侮辱或者诽谤他人，侵害他人合法权益的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.13</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">对他人进行暴力恐吓、威胁，实施人肉搜索的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.14</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">涉及他人隐私、个人信息或资料的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.15</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">散布污言秽语，损害社会公序良俗的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.16</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.17</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.18</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">使用本网站常用语言文字以外的其他语言文字评论的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.19</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">与所评论的信息毫无关系的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.20</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.21</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">侵害未成年人合法权益或者损害未成年人身心健康的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.22</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.23</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）任何暴力和</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">或自残行为内容；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">或财产权利的内容；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.3.24</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">其他违反法律法规、政策及公序良俗、干扰</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">正常运营或侵犯其他用户或第三方合法权益内容的其他信息。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品与服务时，承诺并遵守以下规定：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">实施的所有行为均遵守国家法律、法规等规范性文件及</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议的相关规则。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不发布国家禁止的或涉嫌侵犯他人知识产权或其他合法权益的产品或服务信息，不发布违背社会公共利益或公共道德或</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">认为不适合在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">上发布的产品或服务信息，不发布其他涉嫌违法或违反本协议及各类规则的信息。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">除用户与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">另有约定，用户不得对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">中的任何数据</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">资料作商业性利用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">，包括但不限于在未经</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">事先书面同意的情况下，以复制、传播等任何方式使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">中展示的所有资料或课程。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不使用任何装置、软件或程序干预或试图干预</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的正常运作或正在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">平台上进行的任何交易和活动。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.4.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">除法律另有强制性规定外，未经</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品内的信息内容，否则，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权追究其法律责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">经</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">书面许可后，用户对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件及相关服务的信息和内容的分享、转发等行为，还应符合以下规范：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.5.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不得对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件及相关服务的源网页进行任何形式的任何改动，包括但不限于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件及相关服务的首页链接入口，也不得对</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件及相关服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.5.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">应当采取安全、有效、严密的措施，防止</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件及相关服务的信息内容被第三方通过包括但不限于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">“</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">蜘蛛</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">”</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">（</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">spider</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">）程序等任何形式进行非法获取；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.5.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不得把相关数据内容用于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户充分理解并同意：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户如果违反前述承诺及规范，产生任何法律后果的，用户应以自己的名义独立承担所有的法律责任，并确保</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">免于因此产生的任何损失或增加费用。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户如果违反法律或本协议规定造成</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">被第三人索赔的，用户应全额补偿</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的一切费用（包括但不限于各种赔偿费、诉讼代理费及为此支出的其他合理费用）。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">当第三方认为用户发表、上传的内容</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品（包括但不限于视频、图片、文字、应用程序、软件等）侵犯其权利，或国家行政、司法机关的生效法律文书确认您存在违法、侵权行为，或</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">基于自身判断，认为您的行为违反国家法律法规的规定或涉嫌违反本协议条款的，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权自行决定删除相关信息，并在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">或网站上公示您的涉嫌违法</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">违约行为及对您采取的措施。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">若您发现</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">内用户发布的内容（包括但不限于图片、视频、文字作品等）侵犯您的在先权利，您可以通过致电</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">0731-84484800</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">进行举报。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.5</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">对于用户在</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">中上传、发布、存储作品和内容（包括但不限于图片、视频、文字作品等），用户保证其对该等作品享有合法著作权</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">版权或者相应授权，并且</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户同意授予</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对所有上述作品和内容的在全球范围内的免费、不可撤销的、无限期的、并且可转让的非独家使用权许可</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">，</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权展示、散布及推广前述内容，有权对前述内容进行任何形式的复制、修改、出版、发行及以其他方式使用或者授权第三方进行复制、修改、出版、发行及以其他方式使用。</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">可能会将前述作品和内容用于自身的推广或其他合法目的，若您不同意授权给</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">使用，还请致电</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">0731-84484800</span><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">联系我们。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">8.6.6</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对于用户在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">上涉嫌违法、违约或侵犯他人合法权利的内容、产品，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权不经通知予以删除，且不承担任何责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">免责声明</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户理解并同意，在使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断、延迟。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害（如洪水、台风、地震等）、社会事件（如战争、暴动、政府行为）等，出现上述情况时，</span><span
            style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">会努力对产品和服务进行修复，但由此给您造成的损失，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">在法律允许的范围内免责。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">在法律允许的范围内，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对以下情形导致的服务终端或受阻不承担责任：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户或</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的电脑软件、系统、硬件和通信线路出现故障；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户操作不当；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户使用非</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">授权的方式使用本服务；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.2.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">其他</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">无法控制或合理预见的情形。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户理解并同意，在使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">产品和服务的过程中，可能会遇到网络信息或其他用户带来的风险和损害，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不对任何信息或产品的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.3.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.3.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">因使用本协议项下产品或服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理以及经济上的损害。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">依据本协议享有处理不法、违规内容、产品或服务的权利，但该权利不构成</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的义务和承诺，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">不保证及时发现并做出相应处理。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">9.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对于单项产品运营者通过</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">向您提供的单项产品或服务，由单项产品运营者独立承担与该项产品或服务有关的全部责任和义务，其他</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">对此不承担任何责任和义务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">10.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">产品</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">服务的变更、中止或结束</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户应规范、合法地使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">及服务，如用户发布违法、违背社会公德或违背本协议约定的信息，或有违反相关法律法规或本协议的行为，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权采取以下措施：</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">直接删除违反法律法规或本协议的内容；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">中止或限制您使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">及其产品和服务的权利，包括但不限于限制您使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">部分或全部功能及产品、服务等；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">终止您使用</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">的权利；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">回收您的账号，同时有权禁止您申请或通过其他方式取得新的账号；</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.1.5</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">依法追究您的法律责任，索取相应损害赔偿金。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">有权根据业务发展需要中止、变更、终止</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">产品或其部分功能，并有权决定是否（继续）提供</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">中的某种产品和服务；对于前述情形，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">并不负有向用户通知的义务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">除法律另有规定外，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">用户有责任自行备份存储在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的数据，如用户的服务被终止，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">有权从服务器上永久地删除您在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">的全部相关数据，并不负有向您返还或以任何形式提供前述数据的义务。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">10.4</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">您可以在</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">软件中开启和使用单项或特定服务。某些单项服务可能需要您同时接受就该服务特别制订的协议或者其他约束您与该项服务提供者之间的规则。</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">将以醒目的方式提供这些协议、规则供您查阅。一旦您开始使用上述服务，则视为您同时接受有关单项服务的相关协议、规则的约束。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">11.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">广告</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">11.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户同意</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息；其方式和范围可不经向您特别通知而变更。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">11.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">对于</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">向您发送、推广的广告信息，用户应当自行判断其真实性、可靠性并为自己的判断行为负责。除法律明确规定外，您因该广告信息而进行的交易或遭受的损失</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">/</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">损害，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">不承担责任。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">11.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">用户不得使用未经</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">书面许可的方式屏蔽、过滤广告信息。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">12.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">适用法律及争议解决方式</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">12.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本协议签订地为中华人民共和国长沙市开福区。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">12.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">12.3</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">若您与</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">运营者发生任何纠纷或争议，首先应友好协商解决；协商不成的，</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">您同意将纠纷或争议提交至</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">{{ appName }}</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">所在地法院诉讼解决</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">13.</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #584f60;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: bold;
            text-decoration: none;
            text-transform: none;
          ">其他规定</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">13.1</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">如本协议中的任何条款因任何原因部分无效或不具有执行力，不影响本协议中其余条款对双方的约束力。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
        "><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">13.2</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: Tahoma;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span><span style="
            background-color: #ffffff;
            color: #666666;
            font-family: 宋体;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">本协议条款的标题仅为方便阅读而设，不作为解释本协议条款的依据。</span>
        </p>
        <p style="
          background-color: #ffffff;
          font-size: 10pt;
          line-height: 115%;
          margin: 0pt;
          text-align: justify;
        "><span style="
            background-color: #ffffff;
            color: #2c3e50;
            font-family: 等线;
            font-size: 10pt;
            font-style: normal;
            font-weight: normal;
            text-decoration: none;
            text-transform: none;
          ">&nbsp;</span>
        </p>
        <p style="
          font-size: 10.5pt;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        ">
          <span style="font-family: Calibri; font-size: 10.5pt">&nbsp;</span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import CoachAgreement from './ponents/CoachAgreement.vue'
export default {
  components: { CoachAgreement },
  data() {
    return {
      appName: 'betterWE星球',
      companyName: '长沙健盟网络科技有限公司'
    }
  },
  computed: {
    isCoach() {
      return this.$route.query.appName === 'betterwe教练'
    }
  },
  created() {
    let appName = this.$route.query.appName
    let companyName = this.$route.query.companyName
    this.appName = appName ?? this.appName
    this.companyName = companyName ?? this.companyName
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.agreement {
  padding: 16px;
}
</style>
